function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M0,0h24v24H0V0z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.5,4.5c-0.5-0.5-1.2-0.5-1.7,0L12,10.3L6.1,4.5C5.7,4,4.9,4,4.5,4.5S4,5.7,4.5,6.1l5.9,5.9l-5.9,5.9 c-0.5,0.5-0.5,1.2,0,1.7c0.5,0.5,1.2,0.5,1.7,0l5.9-5.9l5.9,5.9c0.5,0.5,1.2,0.5,1.7,0c0.5-0.5,0.5-1.2,0-1.7L13.7,12l5.9-5.9 C20,5.7,20,4.9,19.5,4.5z"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.9ba16ff8.svg";
export { ForwardRef as ReactComponent };